// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/CalculationComponent.yaml
// Generated: 2026-10-20T12:35:09.266Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCalculationComponent, UpdateCalculationComponent, CalculationComponent } from '@/types/forestry/CalculationComponent';

/**
 * CalculationComponent Service
 * CRUD operations for CalculationComponent via the ABP API.
 */
export const calculationComponentService = new EntityService<CalculationComponent, CreateCalculationComponent, UpdateCalculationComponent>(
  '/api/forestry/calculationcomponent',
  'CalculationComponent',
);
